ShortLinksCtrl.$inject = ['$rootScope', '$scope', '$translate', '$state', '$stateParams', 'PortalApi', 'Notification'];

function ShortLinksCtrl ($rootScope, $scope, $translate, $state, $stateParams, PortalApi, Notification) {
    $scope.preLoader = true;

    $scope.toService = function (urlData) {
        urlData = urlData.plain();

        var stateParams = {
            serviceId: urlData.service_id,
            url: urlData.service_id,
            fields: {},
            destination: '',
            amount: urlData.amount,
            autoCheck: false,
            editForbid: false,
            templateId: true,
            urlCode: $stateParams.urlCode
        };

        if (urlData.opts.auto_check) {
            stateParams.autoCheck = true;
        }

        if (urlData.opts.edit_forbid) {
            stateParams.editForbid = true;
        }

        if (urlData.opts.show_active_state) {
            $rootScope.useShortLink = true;
            $rootScope.show_active_state = true;
        }

        if (urlData.opts.hide_title) {
            $rootScope.hide_title = true;
        }

        if (urlData.opts.destination) {
            stateParams.destination = urlData.opts.destination;
        }


        if (Array.isArray(urlData.fields) && urlData.fields.length) {
            urlData.fields.forEach(function (field) {
                stateParams.fields[field.alias] = {
                    value: field.value
                };
            });
        }

        var parsedLink = urlData.link.split("/")
        parsedLink.forEach(function(key) {
            if (key == 'l') {
                $state.go('pages.payment', stateParams);
            }
            if (key == 'ls') {
                $rootScope.short_link = true;
                $state.go('pages.service', stateParams);
            }
        })

        // $state.go('pages.payment', stateParams);
    };

    $scope.urlNotFound = function () {
        $state.go('pages.error404');
    };

    $scope.getLinkData = function () {
        PortalApi.getShortUrlData($stateParams.urlCode).then(
            $scope.toService,
            $scope.urlNotFound
        );
    };

    $scope.getLinkData();
}

module.exports = ShortLinksCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/shortLinks/controllers/shortLinks.controller.js
 ** module id = 30
 ** module chunks = 1
 **/